import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Payment } from '../../order-v2.types';
import { ClipboardService } from '../../../../../core/services/clipboard/clipboard.service';

@Component({
  selector: 'app-payments-list',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './payments-list.component.html',
  styleUrl: './payments-list.component.scss',
})
export class PaymentsListComponent {
  @Input({ required: true }) payments: Payment[] = [];

  private readonly _clipboard = inject(ClipboardService);

  formatCents(value: number): string {
    return ((value ?? 0) / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  copyPayment(payment: Payment): void {
    const text = `${payment.methodLabel} ${this.formatCents(payment.value)}`;
    this._clipboard.copy(text);
  }
}
